import Main from '../components/Main';
import Nav from '../components/Nav';
import Aside from '../components/Aside';
import Container from '../components/Container';
import Info from '../components/Info';
import Cardcontainer from '../components/Cardcontainer';
import Cardlevel from '../components/Cardlevel';
import { toDate } from '../utils/helpers';

const VistaLevel = ({ user, logout, setName, datos, filter, handleShow }) => {
  return (
    <div className="App">
      <Main>
        <Nav user={user} logout={() => logout(false)} cookDestr={logout} />
        <Aside change={setName} />
        <Container>
          <Info site="level" filter={filter} handleShow={handleShow} />
          <Cardcontainer>
            {datos.data
              .filter(d => {
                if (filter === 'LPP') return d.lpp === '1';
                if (filter === 'MEL') return d.lpp === null;
                return true;
              })
              .map((d, i) =>
                ['EEAA', '980', '960E'].includes(d.kit) ? null : (
                  <Cardlevel
                    key={`${filter}-${i}`}
                    index={i}
                    firm={d.firm}
                    tkd={d.tkd}
                    kit={d.kit}
                    lpp={d.lpp}
                    fuel={d.fuel}
                    cool1={d.cool1}
                    cool2={d.cool2}
                    hid={d.hid}
                    date={toDate(d.unix)}
                    online={d.online}
                    aut={d.aut}
                    pm={d.pm}
                    modelo={d.modelo}
                  />
                )
              )}
          </Cardcontainer>
        </Container>
      </Main>
    </div>
  );
};

export default VistaLevel;
